/*
** 头部显示
*/
import React, { Component } from 'react';
import { Layout, message } from 'antd';

import { getUserInfo } from '../../../apis/api'

const { Header } = Layout;

export default class HeaderCustom extends Component{
    constructor(props){

        super(props);

        this.state = {

            name:''
            
        }
    }

    componentDidMount() {
        const {
            access_token
        } = this.props;
       if(access_token){
       this.setState({
            access_token:access_token?access_token:sessionStorage.getItem('access_token'),
        },()=>{
            this.getUserInfo();
        })
        }
         
      }

    componentWillReceiveProps(nextProps) { 
        const {
            access_token
        } = nextProps;
        if(access_token){
        if(access_token!==this.props.access_token){
               
            this.setState({ access_token:access_token?access_token:sessionStorage.getItem('access_token')
            },()=>{
                this.getUserInfo();
            }) 
        }
        }
      }


    getUserInfo(){

        let _this=this;
        let params={
          access_token:_this.state.access_token,
        }
        getUserInfo(params).then( (data)=> {
  
        if(data.code === 0){

          let name=data.content.user_info.name;

          _this.setState({ name })
          
        }else{

            message.error(data.message); 
        }
        });

      }

    // 退出操作
    logout = ()=>{
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('key');
        sessionStorage.removeItem('openKey');
        this.props.history.push('/login');
    };

    render(){

        // const {  } = this.state;
        const {name} = this.state;

        return(
            <Header style={{ background: '#fff', padding: 0 }} className="header">

                <div className="headerOperate">
                    <span className="username">{name}</span>
                    <span className="logoutBtn" onClick={this.logout}>退出</span>
                </div>
            </Header>
        )
    }
} 


// WEBPACK FOOTER //
// ./src/page/App/common/HeaderCustom.jsx